/** Multi-user presence on the `/presence` socket.io namespace (never stored). */

export const PRESENCE_NAMESPACE = "/presence";

export type PresenceView = "efir" | "control" | "deck" | "classic";
export const PRESENCE_VIEWS: readonly PresenceView[] = ["efir", "control", "deck", "classic"];

export type PresenceMember = {
  id: string;
  userId: string;
  username: string;
  color: string;
  view: PresenceView;
  since: number;
  lastActiveAt: number;
};

/** `anchor: null` — the pointer left the window. */
export type CursorPacket = { id: string; anchor: string | null; x: number; y: number };

export type ActivityPacket = {
  id: string;
  username: string;
  color: string;
  target: string;
  verb: string;
  ts: number;
};

const PALETTE = [
  "#e5484d",
  "#f76b15",
  "#ffc53d",
  "#46a758",
  "#12a594",
  "#0090ff",
  "#8e4ec6",
  "#d6409f",
] as const;

export function presenceColor(username: string): string {
  let h = 0;
  for (const ch of username) h = (h * 31 + (ch.codePointAt(0) ?? 0)) >>> 0;
  return PALETTE[h % PALETTE.length] as string;
}

export function initialsOf(username: string): string {
  const parts = username.split(/[\s._-]+/).filter(Boolean);
  const raw = parts.length > 1 ? `${parts[0]?.[0] ?? ""}${parts[1]?.[0] ?? ""}` : username.slice(0, 2);
  return raw.toUpperCase();
}

const EVENT_VERB: Record<string, string> = {
  goal: "gol yozdi",
  penalty_goal: "penalti gol yozdi",
  own_goal: "avtogol yozdi",
  yellow_card: "sariq berdi",
  second_yellow: "2-sariq berdi",
  red_card: "qizil berdi",
  substitution: "almashtirdi",
};

export function activityOf(
  messageName: string,
  content: unknown,
): { target: string; verb: string } | null {
  const c = (content && typeof content === "object" ? content : {}) as Record<string, unknown>;
  const str = (v: unknown) => (typeof v === "string" && v ? v : null);
  switch (messageName) {
    case "overlay.show": {
      const mode = str(c.mode);
      return mode ? { target: `tile:${mode}`, verb: "efirga chiqardi" } : null;
    }
    case "overlay.off":
    case "overlay.hide": {
      const mode = str(c.mode);
      return mode ? { target: `tile:${mode}`, verb: "efirdan oldi" } : null;
    }
    case "extraTime.show":
      return { target: "tile:little_extra_time", verb: "efirga chiqardi" };
    case "lineup.show": {
      const side = str(c.side);
      return side ? { target: `tile:grid_${side}`, verb: "efirga chiqardi" } : null;
    }
    case "event.add": {
      const playerId = str(c.playerId);
      if (!playerId) return null;
      return { target: `player:${playerId}`, verb: EVENT_VERB[str(c.type) ?? ""] ?? "voqea yozdi" };
    }
    default:
      return null;
  }
}
